import { DateTime } from 'luxon';

// Expects: 2019-04-11T14:53:30+0000
export const formatDate = (dateStrIsoUtc: string, timezone: string, locale: string) => {
  // we DO NOT want "de_DE" but we WANT "de"
  let shortLocale = 'en';
  if (locale && locale.length >= 2) {
    shortLocale = locale.replace(/_.*$/, '');
  }
  try {
    // https://moment.github.io/luxon/docs/manual/parsing.html
    const dt = DateTime.fromISO(dateStrIsoUtc, {
      zone: timezone,
      locale: shortLocale,
    });
    // https://moment.github.io/luxon/docs/manual/formatting.html
    let formattedDate = dt.toLocaleString(DateTime.DATETIME_SHORT);
    if (formattedDate === 'Invalid DateTime') {
      // This happens only in IE11 since it has no timezone support
      // https://moment.github.io/luxon/docs/manual/matrix.html
      // We could use the Polyfill
      // https://github.com/formatjs/date-time-format-timezone
      // BUT: It has 2.8MB full so we simply display the UTC date in a "nicely manner"
      throw new Error('ce-invalid-date-time');
    }
    return formattedDate;
  } catch (err) {
    // FALLBACK1: Display a "nice" UTC Date
    // IN: 2019-04-11T14:53:30+0000
    // OUT: 2019-04-11 14:53 UTC
    try {
      return dateStrIsoUtc.replace('T', ' ').replace('+0000', ' UTC');
    } catch (err2) {
      // FALLBACK2: On error just display the ISO Date String
      return dateStrIsoUtc;
    }
  }
};
